import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContactUpdatePhoneDiffRowResource } from "../../../../shared/types/contactUpdateInquiry";
import {
	ContactUpdateBaseRelationDiffRow,
	ContactUpdateInquiryDiffEntry,
	mapRelationEntry,
} from "./ContactUpdateBaseRelationDiffRow";
import { phoneDiffEntryToIdentifier } from "./contactUpdateUtils";

interface Props {
	row: ContactUpdatePhoneDiffRowResource;
}

export const ContactUpdatePhoneDiffRow: FC<Props> = ({ row }) => {
	const { t } = useTranslation();
	const [field] = useField("phones");
	const value = field.value[row.currentContact.phoneNumber];
	const identifier = phoneDiffEntryToIdentifier(row.currentContact);

	const currentContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.currentContact),
		active: value === "currentContact",
		heading: t("Phone number"),
		value: row.currentContact.phoneNumber,
		onClick: () =>
			field.onChange({
				target: { name: field.name, value: { ...field.value, [identifier]: "currentContact" } },
			}),
	};

	const updatedContact: ContactUpdateInquiryDiffEntry = {
		...mapRelationEntry(row.updatedContact),
		active: value === "updatedContact",
		heading: t("Phone number"),
		value: row.updatedContact.phoneNumber,
		onClick: () =>
			field.onChange({
				target: { name: field.name, value: { ...field.value, [identifier]: "updatedContact" } },
			}),
	};

	return <ContactUpdateBaseRelationDiffRow currentContact={currentContact} updatedContact={updatedContact} />;
};
